import { TranslateDefaultParser } from '@ngx-translate/core';
import * as i0 from "@angular/core";
// plural keys known by nest-18n
const pluralKeys = ['zero', 'one', 'two', 'few', 'many', 'other'];
export let NestI18NTranslateParser = /*#__PURE__*/(() => {
  class NestI18NTranslateParser extends TranslateDefaultParser {
    constructor() {
      super(...arguments);
      // single bracket matcher
      this.templateMatcher = /{\s?([^{}\s]*)\s?}/g;
      this.pluralRules = new Map();
    }
    interpolate(expr, params, language) {
      if (!language) throw new Error('NestI18NTranslateParser.interpolate requires language to be specified.');
      let result;
      if (typeof expr === 'string') {
        result = this.parseTemplateString(expr, params);
      } else if (typeof expr === 'function') {
        throw new Error('Dynamic translate functions are not supported by NestI18NTranslateParser');
      } else if (typeof expr === 'object') {
        result = this.parseTemplateObject(expr, params, language);
      } else {
        // this should not happen, but an unrelated TranslateService test depends on it
        result = expr;
      }
      return result;
    }
    // used by service to extract data from translation tree.
    // by default, also used by interpolateString, for data extraction from params.
    getValue(target, key) {
      return super.getValue(target, key);
    }
    parseTemplateString(template, params) {
      if (!params) {
        return template;
      }
      return template.replace(this.templateMatcher, (substring, b) => {
        const r = this.getValue(params, b);
        return r !== null && typeof r !== 'undefined' ? r : substring;
      });
    }
    parseTemplateObject(template, args, language) {
      const pluralObject = this.getPluralObject(template);
      if (pluralObject && args && args['count'] !== undefined) {
        let translation;
        const count = Number(args['count']);
        const pluralRules = this.getPluralRules(language);
        const pluralCategory = pluralRules.select(count);
        if (count === 0 && pluralObject['zero']) {
          translation = pluralObject['zero'];
        } else if (pluralObject[pluralCategory]) {
          translation = pluralObject[pluralCategory];
        } else {
          // fallback if recommended translation is missing
          translation = pluralObject['many'];
        }
        return translation;
      } else {
        if (template instanceof Array) {
          throw new Error('Arrays are currently unsupported by NestI18NTranslateParser.');
        }
        const result = Object.keys(template).reduce((obj, nestedKey) => {
          // unclear if this can ever happen...
          return {
            ...obj,
            [nestedKey]: this.parseTemplateObject(template[nestedKey], args, language)
          };
        }, {});
        return result;
      }
    }
    getPluralRules(lang) {
      if (!this.pluralRules.has(lang)) {
        this.pluralRules.set(lang, new Intl.PluralRules(lang));
      }
      // console.log('get plural rules for',lang,this.pluralRules.get(lang))
      return this.pluralRules.get(lang);
    }
    getPluralObject(translation) {
      for (const k of pluralKeys) {
        if (translation[k]) {
          return translation;
        }
      }
      return undefined;
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵNestI18NTranslateParser_BaseFactory;
        return function NestI18NTranslateParser_Factory(__ngFactoryType__) {
          return (ɵNestI18NTranslateParser_BaseFactory || (ɵNestI18NTranslateParser_BaseFactory = i0.ɵɵgetInheritedFactory(NestI18NTranslateParser)))(__ngFactoryType__ || NestI18NTranslateParser);
        };
      })();
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: NestI18NTranslateParser,
        factory: NestI18NTranslateParser.ɵfac
      });
    }
  }
  return NestI18NTranslateParser;
})();